import ENDPOINTS from "@/providers/end-points";
import requests from "@/providers/requests";
import { Menu } from "@/modules/ooc";
import { Translate as $t } from "@/plugins/translate";
import { Item } from "@/modules/location";
import Category from "@/modules/ooc/category";
const _ = window["_"];
export default {
  namespaced: true,
  state: {
    list: [],
    count: 0,
    catalogCount: 0,
    success: false,
    menu: null,
    message: "",
    catalog: [],
    catalogItems: [],
    category: null,
    stagedItems: [],
    originalCatalog: [],
    searchedItems: [],
    selectedItem: null,
    selectedVariation: null,
    selectedModifier: null,
  },
  getters: {
    list: (state: any): Array<any> => state.list,
    count: (state: any): number => state.count,
    catalogCount: (state: any): number => state.catalogCount,
    success: (state: any): boolean => state.success,
    message: (state: any): string => state.message,
    menu: (state: any): any => state.menu,
    catalog: (state: any): any => state.catalog,
    catalogItems: (state: any): any => state.catalogItems,
    category: (state: any): any => state.category,
    stagedItems: (state: any): any => state.stagedItems,
    originalCatalog: (state: any): any => state.originalCatalog,
    searchedItems: (state: any): any => state.searchedItems,
    selectedItem: (state: any): any => state.selectedItem,
    selectedVariation: (state: any): any => state.selectedVariation,
    selectedModifier: (state: any): any => state.selectedModifier,
    originalItem: (state: any): any => state.originalItem,
  },
  mutations: {
    SET_MENU_LIST(state: any, payload) {
      state.list = payload.data;
      state.count = payload.count;
    },
    SET_RESPONSE(state: any, { success = false, message = "" }) {
      state.success = success;
      state.message = message;
    },

    SET_MENU(state: any, payload) {
      state.menu = new Menu(payload);
    },
    SET_CATALOG_CATEGORIES(state: any, payload: Array<any>) {
      state.catalog = [];
      payload.forEach((catalog) => {
        // push to catalogs
        if (catalog.items_count != 0) {
          state.catalog.push(new Category(catalog));
        }
      });
    },
    SET_CATALOG_ITEMS(state: any, payload) {
      state.catalogItems = payload;
    },
    SET_STAGED_ITEMS(state: any, payload) {
      state.stagedItems = payload;
    },
    SET_ORIGINAL_CATALOG(state: any, payload) {
      state.originalCatalog = [...state.originalCatalog, ...payload];
    },
    SET_SELECTED_ITEM(state: any, payload) {
      state.selectedItem = payload;
    },
    SET_SELECTED_VARIATION(state: any, payload) {
      state.selectedVariation = payload;
    },
    SET_SELECTED_MODIFIER(state: any, payload) {
      state.selectedModifier = payload;
    },
    SET_CATALOG_COUNT(state: any, count) {
      state.catalogCount = count;
    },
    SET_SEARCHED_ITEMS(state: any, payload) {
      state.searchedItems = payload;
    },
  },
  actions: {
    /***
     * get menus will get you all the menus associated with one location
     * @param commit
     * @param page
     * @param itemsPerPage
     * @param search
     * @param businessId
     * @param branchId to query by branch
     */
    async getMenus(
      { commit }: { commit: any },
      { page = 1, itemsPerPage = 15, search = null, businessId = "", branchId = "" }
    ) {
      return await requests
        .get(
          `${ENDPOINTS.OOC_BASE_URL}${ENDPOINTS.OOC.MENUS(
            businessId
          )}?page=${page}&page_size=${itemsPerPage}&name=${search}&location_id=${branchId}`
        )
        .then((response) => response.data)
        .then(({ data, meta }) => ({
          data: data.map((item) => new Menu(item)),
          count: meta.total_records,
        }))
        .then(async ({ data, count }) => {
          await commit("SET_MENU_LIST", { data, count });
        })
        .catch(async (error) => {
          await console.log(error);
        });
    },
    /***
     *
     * @param commit
     * @param payload
     */
    async createMenu({ commit }: { commit: any }, payload) {
      const { businessId, body } = payload;
      return await requests
        .post(`${ENDPOINTS.OOC_BASE_URL}${ENDPOINTS.OOC.MENUS(businessId)}`, body)
        .then((response) => {
          return response.data;
        })
        .then(async (response) => {
          await commit("SET_RESPONSE", { success: true, message: response?.message || $t("saved_successfully") });
          await commit("SET_MENU", response.data);
        })
        .catch(async (error) => {
          await commit("SET_RESPONSE", {
            success: false,
            message: error.message || $t("data_not_saved_yet"),
          });
        });
    },

    /***
     * Edits menu categories
     * @param commit
     * @param businessId
     * @param menuId
     * @param body
     */
    async editMenu({ commit }: { commit: any }, { businessId, menuId, body }) {
      return await requests
        .put(`${ENDPOINTS.OOC_BASE_URL}${ENDPOINTS.OOC.EDIT_MENU(businessId, menuId)}`, body)
        .then((response) => {
          return response.data;
        })
        .then(async (response) => {
          await commit("SET_RESPONSE", { success: true });
          await commit("SET_MENU", new Menu(response.data));
          await commit("SET_RESPONSE", {
            success: true,
            message: response?.message || $t("saved_successfully"),
          });
        })
        .catch(async (error) => {
          await commit("SET_RESPONSE", {
            success: false,
            message: error?.message || $t("data_not_saved_yet"),
          });
        });
    },

    async getCatalogCategories(
      { commit }: { commit: any },
      { page = 1, pageSize = 15, businessId, name = "", location_id }
    ) {
      return await requests
        .get(
          `${ENDPOINTS.OOC_BASE_URL}${ENDPOINTS.OOC.CATALOG_CATEGORIES(
            businessId
          )}?page=${page}&page_size=${pageSize}&name=${name}&location_id=${location_id}`
        )
        .then((response) => response.data)
        .then(async ({ data, meta }) => {
          await commit("SET_CATALOG_COUNT", meta.total_records);
          await commit("SET_CATALOG_CATEGORIES", data);
        })
        .catch(async (error) => {
          await console.log(error);
        });
    },
    /***
     *
     * @param commit
     * @param businessId
     * @param menuId
     */
    async getMenu({ commit }: { commit: any }, { businessId, menuId }) {
      return await requests
        .get(`${ENDPOINTS.OOC_BASE_URL}${ENDPOINTS.OOC.ONE_MENU(businessId, menuId)}`)
        .then((response) => response.data)
        .then(async (data) => {
          await commit("SET_MENU", data.data);
        })
        .catch(async (error) => {
          await commit("SET_MENU", {});
          await console.log(error);
        });
    },
    /**
     * get catalog items for one id
     * @param commit
     * @param page
     * @param pageSize
     * @param businessId
     * @param name
     * @param locationId
     * @param categoryId
     * @param items
     */
    async getCatalogItems(
      { commit }: { commit: any },
      { page = 1, pageSize = 25, businessId, name = "", locationId, categoryId = "", items = [] }
    ) {
      return await requests
        .get(
          `${ENDPOINTS.OOC_BASE_URL}${ENDPOINTS.OOC.CATALOG_ITEMS(
            businessId,
            locationId
          )}?page=${page}&page_size=${pageSize}&category_id=${categoryId}&name=${name}`
        )
        .then((response) => response.data)
        .then(({ data }) => ({
          data: data.map((item) => new Item(item).prepareOocItem()),
        }))
        .then(async ({ data }) => {
          if (data.length !== 0) {
            let cloned = _.cloneDeep(data);
            await commit("SET_CATALOG_ITEMS", [...items, ...cloned]);
            await commit("SET_ORIGINAL_CATALOG", data);
          }
        })
        .catch(async (error) => {
          await console.log(error);
          await commit("SET_CATALOG_ITEMS", []);
          await commit("SET_ORIGINAL_CATALOG", []);
        });
    },
    async getCatalogItemsForMultipleCategories(
      { commit }: { commit: any },
      { page = 1, pageSize = 30, businessId, name = "", locationId = "", categoryIds = [] }
    ) {
      let categories = "";
      categoryIds.forEach((id) => {
        categories += `&category_id=${id}`;
      });
      return await requests
        .get(
          `${ENDPOINTS.OOC_BASE_URL}${ENDPOINTS.OOC.CATALOG_ITEMS(
            businessId,
            locationId
          )}?page${page}&page_size=${pageSize}${categories}&name=${name}`
        )
        .then((response) => response.data)
        .then(({ data }) => ({
          data: data.map((item) => new Item(item).prepareOocItem()),
        }))
        .then(async ({ data }) => {
          await commit("SET_SEARCHED_ITEMS", data);
          await commit("SET_ORIGINAL_CATALOG", data);
        })
        .catch(async (error) => {
          await console.log(error);
          await commit("SET_CATALOG_ITEMS", []);
          await commit("SET_ORIGINAL_CATALOG", []);
        });
    },

    async publishMenu({ commit }: { commit: any }, { businessId, locationId, integrationId, menuId }) {
      return await requests
        .post(
          `${ENDPOINTS.OOC_BASE_URL}${ENDPOINTS.OOC.PUBLISH_INTEGRATIONS(
            businessId,
            locationId,
            integrationId,
            menuId
          )}`
        )
        .then(async (response) => {
          return await commit("SET_RESPONSE", {
            success: true,
            message: response?.data?.message || $t("saved_successfully"),
          });
        })
        .catch(async ({ error }) => {
          await commit("SET_RESPONSE", {
            success: false,
            message: error?.message || $t("data_not_saved_yet"),
          });
        });
    },
  },
};
